import { apiFetch } from './auth-service';

export interface PublishedPitch {
  _id: string;
  problem: string;
  solution: string;
  marketSize: string;
  businessModel: string;
  traction: string;
  team: string;
  financials: string;
  askAmount: string;
  useOfFunds: string;
  competitiveAdvantage: string;
  equityOffered: string;
  preMoneyValuation: string;
  fileUrl: string;
  userId: { name: string } | null;
  startupId: {
    name: string;
    tagline: string;
    industry: string;
    stage: string;
    teamSize: number;
    coFounders: any[];
    description: string;
    website: string;
  } | null;
  isInterested?: boolean;
  updatedAt: string;
  createdAt: string;
}

export const getPublishedPitches = (): Promise<PublishedPitch[]> =>
  apiFetch.get<{ pitches: PublishedPitch[] }>('/investor/pitches').then(r => r.pitches);

export const getPitchDetail = (id: string): Promise<PublishedPitch> =>
  apiFetch.get<{ pitch: PublishedPitch }>(`/investor/pitches/${id}`).then(r => r.pitch);

export const requestSession = (
  pitchId: string,
  data: { days: string[]; times: string[]; callFormat: 'video' | 'phone'; duration: number },
): Promise<void> =>
  apiFetch.post(`/investor/pitches/${pitchId}/session-request`, data).then(() => {});
